var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 0L13.47 3.87101C13.6344 3.9783 13.7638 4.11953 13.8583 4.29471C13.9528 4.46988 14 4.65622 14 4.85371V12.6613C14 13.0354 13.8711 13.352 13.6132 13.6112C13.3553 13.8704 13.0402 14 12.668 14H1.33199C0.959789 14 0.644738 13.8704 0.386843 13.6112C0.128948 13.352 0 13.0354 0 12.6613V4.85371C0 4.65622 0.0472379 4.46988 0.141714 4.29471C0.236177 4.11953 0.365591 3.9783 0.529957 3.87101L7 0ZM7 8.18639L12.7474 4.74262L7 1.29885L1.25262 4.74262L7 8.18639ZM7 9.48524L1.10525 5.94462V12.6613C1.10525 12.7277 1.12651 12.7823 1.16902 12.8251C1.21154 12.8678 1.26586 12.8892 1.33199 12.8892H12.668C12.7341 12.8892 12.7885 12.8678 12.831 12.8251C12.8735 12.7823 12.8948 12.7277 12.8948 12.6613V5.94462L7 9.48524ZM7 12.8892H12.8948H1.10525H7Z",
    fill: "#959393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen);
export default __webpack_public_path__ + "static/media/email-open.c25e414053aaff1cc40dfb3a4bb0a1c2.svg";
export { ForwardRef as ReactComponent };